import { RouterProvider } from 'react-router';
import { browserRouter } from './browser-router';

export function Router() {
  return <RouterProvider router={browserRouter} />;
}
